import React from 'react';
import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';
import PropTypes from 'prop-types';
import translate from '@/lib/intl/translate';
import useBulkActionStatus from '../lib/useBulkActionStatus';

export default function BulkActionStatus({ className }) {
  const { data, error, isValidating } = useBulkActionStatus();
  const [display, setDisplay] = React.useState(false);

  React.useEffect(() => {
    if (data?.totalHits > 0) setDisplay(true);
  }, [data]);

  if (!data || error || isValidating || !display) return null;

  return (
    <Slide direction="down" in={display} mountOnEnter unmountOnExit>
      <Alert
        className={className}
        color="warning"
        icon={false}
        onClose={() => {
          setDisplay(false);
        }}
      >
        {translate('BULK_ACTION_STATUS_IN_PROGRESS', {
          count: data?.totalHits,
        })}
      </Alert>
    </Slide>
  );
}

BulkActionStatus.propTypes = {
  className: PropTypes.string,
};

BulkActionStatus.defaultProps = {
  className: '',
};
